@if (!canAccess) {
  <app-no-permissions></app-no-permissions>
}
<div class="grid">
  <div class="col-2">
    <p-panelMenu [model]="items" [multiple]="true"></p-panelMenu>
  </div>
  <div class="col-10">
    <router-outlet name="panel"></router-outlet>
  </div>
</div>
